<template>
  <div class="page-wrapper">
    <div class="list">
      <div v-if="useBannerData.length" class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, i) in useBannerData" :key="i">
            <!-- @click="toWapDetail(item, true)" -->
            <div class="img">
              <img
                v-if="item.flag == 36 &&  item.sub_list &&  item.sub_list.length"
                :src="(id == indexChannel.channel_id ? item.sub_list[0].img_169:item.sub_list[0].img_url) || require('@/assets/img/default_16_9.png')"
                :onload="imgLoaded"
                :onerror="errorImg"
                alt
              />
              <img
                v-else
                :src="(id == indexChannel.channel_id ? item.img_169 || item.img_url :item.img_url) || require('@/assets/img/default_16_9.png')"
                :onload="imgLoaded"
                :onerror="errorImg"
                alt
              />
              <span v-show="item.newsKind == 4" class="video-icon"></span>
            </div>
            <div class="title">
              <!-- item.label && item.flag != 5 -->
              <div class="titleName">
                <span
                  v-show="labelTxtFilter(item.label)"
                  class="label-banner-wap"
                  :class="`label-class-${item.label}`"
                >{{ labelTxtFilter(item.label) }}</span>
                <span
                  v-if="item.flag == 36 && item.sub_list && item.sub_list.length"
                >{{item.sub_list[0].news_title}}</span>
                <span v-else>{{ item.news_title }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination" slot="pagination"></div>
      </div>
      <NewsList v-if="list.length + bannerList.length" :isSubjectList="isSubjectChannel" :list="list" :bannerList="bannerList"></NewsList>
      <div v-show="isLoading || isAll" class="loadMore">{{ isAll ? '已经到底了' : '加载更多...' }}</div>
    </div>
  </div>
</template>
<script>
import JumpDetailHook from "@/mixins/jumpDetailHook.js";
import Swiper from "swiper/js/swiper.min.js";
import "swiper/css/swiper.css";
import NewsList from "@/components/wap/NewsList";
import { mapState, mapMutations } from "vuex";
let _vm = null;
export default {
  name: "subjectResult",
  mixins: [JumpDetailHook],
  data() {
    return {
      list: [],
      bannerList: [],
      page: 1,
      isAll: false,
      news_id: null,
      page_size: 25,
      unBindScroll: null,
      swiper: null,
      isLoading: false,
      type: null, // 1-栏目文章列表 3-H5列表 4-所有专题 5-分类专NU题列表 6-专题专栏集合栏目
      id: null, // type == 5 --- 专题id，其他情况代表栏目id
      skId: null, // 专题分类列表id
      lastDataId: null, // 1,3,6 文章，H5，专题专栏集合栏目
      subjectList: null,
      subjectLastId: null, // 4 专题
      subjectKindLastId: null, // 5 分类专题新闻列表lastId
      topImg: null, // 专题分类头图
      kindName: "", // 专题分类名称
      imgLoaded: `this.style.background = 'none'`,
      errorImg: 'this.src="' + require("@/assets/img/default_4_3.png") + '"',
      errorTopImg: `this.parentNode.style.backgroundImage = 'url("${require("@/assets/img/default_4_3.png")}")'`, // 分类专题头图加载失败
      channelId: null,
      channelType: null,
      bannerData: [],
    };
  },
  components: {
    NewsList
  },
  async created() {
    this.type = this.$route.params.type;
    this.channel_type = this.$route.params.type;
    this.id = this.$route.params.id;
    _vm = this;
    // this.skId = this.$route.params.skId;
    // this.getTitle(); // document.title

    setTimeout(() => {
      this.setIsShowWapHeader(true);
    }, 200);
  },
  async mounted() {
    await this.getData(true); // 为true代表第一次请求
    this.initSwiper();
    // window.scrollTo(0, 0);
    this.$Common.onShare({
      shareUrl: window.location.href
    });
  },
  beforeDestroy() {
    this.swiper = null;
    this.unBindScroll && this.unBindScroll();
  },
  methods: {
    ...mapMutations(["setLoadingShow", "setIsShowWapHeader"]),
    async getData(flag = false) {
      const {
        type: channel_type,
        id: channel_id,
        page,
        page_size,
        news_id,
        isAll
      } = this;

      if (this.isLoading || isAll) return;
      this.isLoading = true;

      const paramsObj = {
        kind: 1,
        channel_type,
        channel_id,
        page,
        page_size,
        bannerSize: 8,
        bannerNewsKindIn: "[4,3,11,5,9,10,6]",
        listNewsKindIn: "[4,3,11,5,9,10,6]"
      };
      if (flag && this.isSubjectChannel) delete paramsObj.subject_id;
      if (news_id) paramsObj.news_id = news_id;
      if (!flag && this.isSubjectChannel) paramsObj.subject_id = this.news_id;
      if (!flag && this.isSubjectChannel) delete paramsObj.news_id;
      return new Promise(resolve => {
        +(async () => {
          let {
            list,
            banner = [],
            last_subject_id,
            last_news_id,
            newsWebHot = null,
            mainNews = []
          } = await this.$axios.post(
            this.isSubjectChannel
              ? this.$ApiInfo.getSubList
              : this.$ApiInfo.getList,
            "data=" + JSON.stringify(paramsObj),
            false
          );
          this.news_id = this.isSubjectChannel ? last_subject_id : last_news_id;
          this.isAll = list.length + banner.length < page_size;
          this.page++;
          if (this.isSubjectChannel) {
            list = list.map(v => {
              v.name = v.subject_name;
              v.img_url = v.big_img;
              v.news_title = v.subject_name;
              return v;
            });
          }
          if(this.id == this.indexChannel.channel_id) this.list.push(...banner)
          this.list.push(...list);
          this.bannerList.push(...banner);
          await this.$nextTick();
          this.isLoading = false;
          if (flag) {
            this.setLoaing();
            this.bannerData = [newsWebHot, ...mainNews]
              .filter(Boolean)
              .map(item => {
                if (item.flag == 30 || item.flag == 13) {
                  if (!item.label) item.label = 1;
                }
                if (item.flag == 36) {
                  if (!item.label) item.label = 13;
                }
                return item;
              });
          }
          resolve();
        })();
      });
      // if(this.type == 1) {
      //   this.getColumnNews(flag);
      // }
      // else if(this.type == 3) {
      //   this.getGroupList(flag);
      // }
      // else if(this.type == 4) {
      //   this.getSubjects(flag);
      // }
      // else if(this.type == 5) {
      //   this.getSubjectNews(flag);
      // }
      // else if(this.type == 6) {
      //   this.getColumnSubjects(flag)
      // }
    },

    labelTxtFilter(label) {
      return [
        "",
        "专题",
        "",
        "",
        "",
        "",
        "直播中",
        "直播回放",
        "",
        "",
        "",
        "",
        "",
        "专栏",
        "",
        "",
        "直播预告",
        ""
      ][label];
    },
    initSwiper() {
      this.swiper = new Swiper(".swiper-container", {
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: true,
        on: {
          click(e) {
            if (e.type === "mouseup") return;

            let i = this.realIndex;
            let item = _vm.useBannerData[i];

            _vm.toWapDetail(item);
          }
        }
      });
    },
    getColumnNews(flag) {
      if (this.lastDataId == -1 || !this.id) {
        return;
      }
      this.$axios
        .post(this.$ApiInfo.getColumnNews, {
          page: this.page,
          pageSize: this.pageSize,
          lastDataId: this.lastDataId,
          columnId: this.id // 栏目id
        })
        .then(data => {
          this.lastDataId = data.lastDataId;
          this.page++;
          this.list.push(...data.list);
          this.isLoading = false;
          flag && this.setLoaing();
        });
    },
    getGroupList(flag) {
      if (this.lastDataId == -1 || !this.id) {
        return;
      }
      this.$axios
        .post(this.$ApiInfo.getGroupList, {
          columnId: this.id // 栏目id
        })
        .then(data => {
          this.lastDataId = -1;
          data && data.length && this.list.push(...data);
          this.isLoading = false;
          flag && this.setLoaing();
        });
    },
    getSubjects(flag) {
      if (this.subjectLastId == -1) {
        return;
      }
      this.$axios
        .post(this.$ApiInfo.getSubjects, {
          page: this.page,
          pageSize: this.pageSize,
          lastDataId: this.subjectLastId
        })
        .then(data => {
          this.subjectLastId = data.lastDataId;
          this.page++;
          data.list && data.list.length && (this.subjectList = data.list);
          this.isLoading = false;
          flag && this.setLoaing();
        });
    },
    getSubjectNews(flag) {
      if (this.subjectKindLastId == -1 || !this.id || !this.skId) {
        return;
      }
      this.$axios
        .post(this.$ApiInfo.getSubjectDetail, {
          id: this.id,
          skId: this.skId,
          page: this.page,
          pageSize: this.pageSize,
          skNewsListPageSize: this.pageSize,
          lastDataId: this.subjectKindLastId
        })
        .then(data => {
          if (data) {
            data.name && (document.title = data.name);
            data.topImgUrl && (this.topImg = data.topImgUrl);
            if (data.subjectKindList && data.subjectKindList[0]) {
              data.subjectKindList[0].name &&
                (this.kindName = data.subjectKindList[0].name);
              data.subjectKindList[0].newsList &&
                data.subjectKindList[0].newsList.length &&
                this.list.push(...data.subjectKindList[0].newsList);
              this.subjectKindLastId = data.subjectKindList[0].lastDataId;
              this.page++;
            }
          }
          this.isLoading = false;
          flag && this.setLoaing();
        });
    },
    getColumnSubjects(flag) {
      if (this.lastDataId == -1 || !this.id) {
        return;
      }
      this.$axios
        .get(this.$ApiInfo.getColumnSubjects, {
          page_size: this.pageSize,
          lastDataId: this.lastDataId,
          column_id: this.id // 栏目id
        })
        .then(data => {
          this.lastDataId = data.lastDataId;
          this.page++;
          this.list.push(...data.list);
          this.isLoading = false;
          flag && this.setLoaing();
        });
    },
    setInit() {
      this.page = 1;
      this.list = [];
      this.isLoading = false;
      this.type = null;
      this.id = null;
      this.skId = null;
      this.lastDataId = null;
      this.subjectList = null;
      this.subjectLastId = null;
      this.subjectKindLastId = null;
      this.topImg = null;
      this.kindName = "";
    },
    getTitle() {
      if (this.$route.params.type == 1 || this.$route.params.type == 3) {
        this.columnList &&
          this.columnList.length &&
          this.columnList.map(v => {
            if (v.id == this.$route.params.id) {
              document.title = v.name;
            }
          });
      }
    },
    setLoaing() {
      this.setLoadingShow(false);
      this.$nextTick(() => {
        let footerHeight = 0;
        document.querySelector(".footer-wrapper") &&
          (footerHeight =
            document.querySelector(".footer-wrapper").clientHeight - 100);
        this.unBindScroll = this.$Common.loadScroll(footerHeight, this.getData);
      });
    }
  },
  computed: {
    ...mapState(["indexChannel", "columnList"]),
    isPhone() {
      return this.$Common.Attribute.isMb();
    },
    pageSize() {
      return this.isPhone ? 20 : 45;
    },
    colums() {
      return this.columnList;
    },
    useBannerData() {
      if (this.indexChannel && this.id == this.indexChannel.channel_id) {
        return this.bannerData;
      } else {
        return this.bannerList;
      }
    },
    isSubjectChannel() {
      return this.type == 29;
    }
  },
  watch: {
    $route(val) {
      if (
        val.params &&
        (val.params.type != this.type || val.params.id != this.id)
      ) {
        this.setInit();
        this.type = val.params.type;
        this.id = val.params.id;
        this.skId = val.params.skId;
        // this.getData(true);
        this.getTitle();
      }
    },
    colums(val) {
      if (this.$route.params.type == 1 || this.$route.params.type == 3) {
        val &&
          val.length &&
          val.map(v => {
            if (v.id == this.$route.params.id) {
              document.title = v.name;
            }
          });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.label-banner-wap {
  margin-right: 4px;
}
.swiper-container {
  .swiper-wrapper {
    transform: translate3d(0, 0, 0);
    .swiper-slide {
      position: relative;
      width: 100vw;
      transform: translate3d(0, 0, 0);
      .img {
        width: 100vw;
        height: 56.267vw;
        position: relative;

        .video-icon {
          position: absolute;
          width: 11.667vw;
          height: 11.667vw;
          background: url("../../assets/img/video_play.png") center no-repeat;
          background-size: cover;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .title {
        position: absolute;
        bottom: 0;
        font-size: 4.533vw;
        line-height: 6.4vw;
        color: #fff;
        width: 100vw;
        box-sizing: border-box;
        padding: 6.8vw 4vw 6.4vw;
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0.8) 100%
        );

        .titleName {
          // height: 12.8vw;
        }
      }
    }
  }

  .swiper-pagination {
    box-sizing: border-box;
    text-align: right;
    padding-right: 8px;

    .swiper-pagination-bullet {
      width: 6px;
      height: 6px;
      background: #d8d8d8;
      opacity: 0.5;
      outline: none;
    }

    .swiper-pagination-bullet-active {
      background: #006df1;
      opacity: 0.7;
    }
  }
}
.page-wrapper {
  min-height: calc(100vh - 13.067vw);
}

.subject-kind-list {
  .subject-topImg {
    width: 100%;
    height: auto;
    margin-bottom: 1.5rem;

    .img {
      display: block;
      width: 100%;
      height: 12.75rem;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      background-image: url("../../assets/img/default.png");
    }
  }

  .classify-title {
    color: #006df1;
    border-left: 0.1875rem solid #006df1;
    text-indent: 0.5em;
    margin-bottom: 0.875rem;
    line-height: 1.125rem;
    // .title {
    //     float: left;
    // }
  }
}

.wap-wrapper {
  .subject-kind-list {
    .subject-topImg {
      display: none;
    }

    .classify-title {
      display: none;
    }
  }
}

.subject-message {
  margin-top: 0.625rem;
  margin-bottom: 1.5rem;
  color: #fff;

  .subject-message-title {
    font-size: 1.125rem;
    line-height: 1.5625rem;
    border-bottom: 0.125rem solid #fff;
    padding-bottom: 0.25rem;
  }
}

.no-subject-result {
  color: #fff;
}
</style>